import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useCart } from '../contexts/CartContext';

const Header = () => {
    const location = useLocation();
    const { getTotalItems } = useCart();
    const totalItems = getTotalItems();

    return (
        <div id="header">
            {/* Logo */}
            <h1>
                <Link to="/" id="logo">
                    <img src="/images/gm-de-coracao-logo.png" width="150" alt="GM de Coração" />
                </Link>
            </h1>

            {/* Nav */}
            <nav id="nav">
                <ul>
                    <li className={location.pathname === '/' ? 'current' : ''}>
                        <Link to="/">Home</Link>
                    </li>
                    <li className={location.pathname === '/quem-somos' ? 'current' : ''}>
                        <Link to="/quem-somos">Quem somos</Link>
                    </li>
                    {/* <li className={location.pathname === '/articulados' ? 'current' : ''}>
                        <Link to="/articulados">Articulados</Link>
                    </li>
                    <li className={location.pathname === '/cubos-infinitos' ? 'current' : ''}>
                        <Link to="/cubos-infinitos">Cubos Infinitos</Link>
                    </li>
                    <li className={location.pathname === '/spinners' ? 'current' : ''}>
                        <Link to="/spinners">Spinners</Link>
                    </li>
                    <li className={location.pathname === '/educacional' ? 'current' : ''}>
                        <Link to="/educacional">Auxílio Educacional</Link>
                    </li>
                    <li className={location.pathname === '/customizados' ? 'current' : ''}>
                        <Link to="/customizados">Customizados</Link>
                    </li> */}
                    <li>
                        <Link to="/carrinho" style={{ position: 'relative' }}>
                            <i className="fas fa-shopping-cart" style={{ marginRight: '5px' }}></i> Carrinho
                            {totalItems > 0 && (
                                <span style={{
                                    position: 'absolute',
                                    top: '-8px',
                                    right: '-8px',
                                    backgroundColor: '#ff4444',
                                    color: 'white',
                                    borderRadius: '50%',
                                    width: '20px',
                                    height: '20px',
                                    fontSize: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontWeight: 'bold'
                                }}>
                                    {totalItems}
                                </span>
                            )}
                        </Link>
                    </li>
                </ul>
            </nav>
        </div>
    );
};

export default Header;
